import React, { useEffect, useState } from 'react'
import PageHead from '../components/PageHead'
import Container from '../ui/comp/Container'
import Input from '../ui/forms/Input'
import TextArea from '../ui/forms/TextArea'
import Select from '../ui/comp/Select'
import Checkbox from '../ui/forms/Checkbox'
import Button from '../ui/comp/Button'
import { useMutation, useQuery } from '@tanstack/react-query'
import { Axios } from '../utils/Axios'
import UploadSelect from '../components/UploadSelect'
import { IoTrash } from 'react-icons/io5'
import { useCategory } from '../hooks/useCategory'
import { useNavigate, useParams } from 'react-router-dom'
import Loading from '../components/Loading'
import { displayImage, formatDateForInput } from '../utils/config'
import ImageContainer from '../ui/comp/ImageContainer'
import FroalaEditor from 'react-froala-wysiwyg'


function EditProduct() {

    const [fileExploreOpen, setFileExploreOpen] = useState(false)

    const { slug } = useParams();

    const { data: productData, isLoading: productIsloading } = useQuery({
        queryKey: [slug],
        queryFn: async () => {
            const res = await Axios.get(`/product/get/${slug}`)
            return res.data
        }
    })

    const navigate = useNavigate()


    const [formData, setFormData] = useState({
        name: "",
        description: "",
        base_price: "",
        stock: "",
        discount: "",
        customable: false,
        in_stock: true,
        isBundleProduct: false,
        customise_price: 0.00,
        dealPrice: 0,
        sub_category: "",
        dealStart: "",
        dealEnd: "",
        subcategories: []
    })


    useEffect(() => {
        console.log(productData);

        setImages(productData?.images || [])

        setFormData(
            {
                name: productData?.name,
                description: productData?.description,
                base_price: productData?.base_price,
                stock: productData?.stock,
                discount: productData?.discount,
                customable: productData?.customable,
                in_stock: productData?.in_stock,
                customise_price: productData?.customise_price,
                isBundleProduct: productData?.isBundleProduct,
                dealPrice: productData?.dealPrice,
                dealStart: productData?.dealStart,
                subcategory: productData?.subcategory,
                dealEnd: productData?.dealEnd,
                sub_category: productData?.sub_category,
                subcategories: productData?.subcategories,
            }
            ||
            {
                name: "",
                description: "",
                base_price: "",
                stock: "",
                discount: "",
                customable: false,
                in_stock: true,
                isBundleProduct: false,
                dealPrice: 0.00,
                dealStart: "",
                dealEnd: "",
                sub_category: "",
                subcategories: []
            })

    }, [productData])

    useEffect(() => {
        setIsPromo(!!productData?.dealPrice)
    }, [productData])

    const [images, setImages] = useState([]);

    const [isPromo, setIsPromo] = useState(false)


    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value })
    }

    // Updating Product

    const { mutate, isPending, error, isSuccess } = useMutation({
        mutationFn: async (formData) => {
            return Axios.post(`/product/update/${productData?.id}`, formData)
        }
    })


    if (isSuccess) {
        navigate('/products')
    }

    const addProduct = (e) => {

        e.preventDefault()

        if (!images.length) {
            window.alert("Product images reaguired")
            return;
        }
        mutate({ ...formData, images: JSON.stringify(images), isPromo: isPromo })
    }

    if (error) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    const handleExploreOpen = () => {
        setFileExploreOpen(!fileExploreOpen)
    }

    // Get Seletected Images
    const getSelectedImages = (files) => {
        setImages(files)
    }

    const { data: categories } = useCategory()


    if (productIsloading) {
        return <Loading />
    }

    return (
        <div className='w-full relative'>

            {fileExploreOpen ? (
                <UploadSelect onClose={handleExploreOpen} sendFiles={getSelectedImages} />
            ) : null}

            <PageHead title="Update Product" />

            {/* Product Form */}
            <div className="w-full mt-8">
                <Container border={true}>
                    {error && (
                        <div className='text-red-500 my-5 text-sm capitalize'>{error?.response?.data || error.message}</div>
                    )}
                    {/* Form */}
                    <div className="flex gap-7 py-5 flex-col xl:flex-row w-full">

                        {/* Form 1 ==========================================  */}
                        <div className="w-full space-y-7 xl:w-7/12">

                            {/* Product Name */}

                            <div className='space-y-2'>
                                <h4 className="font-medium text-sm">Product Name</h4>
                                <Input
                                    id="name"
                                    value={formData.name}
                                    placeholder="Type name here"
                                    onChange={handleInputChange}
                                />
                            </div>

                            {/* Description */}

                            <div className='space-y-2'>
                                <h4 className="font-medium text-sm">Product Description</h4>
                                <FroalaEditor
                                    tag="textarea"
                                    model={formData?.description}
                                    onModelChange={(data) => setFormData({ ...formData, description: data })}
                                />
                            </div>

                            {/* Category and stock */}


                            <div className="flex gap-4">

                                <div className='space-y-2 w-full'>
                                    <h4 className="font-medium text-sm">Category</h4>
                                    <Select value={formData?.sub_category} classic={true}
                                        onChange={(e) => setFormData({ ...formData, sub_category: e.target.value })
                                        }
                                    >
                                        {formData?.subcategories?.map((category, i) => (
                                            <option key={i} value={`${category?.id}`}>{`${category?.name}`}</option>
                                        ))}
                                    </Select>
                                </div>

                                <div className='space-y-2 w-full'>
                                    <h4 className="font-medium text-sm">Product Stock</h4>
                                    <Input
                                        id='stock'
                                        value={formData.stock}
                                        onChange={handleInputChange}
                                        placeholder="Stock"
                                    />
                                </div>

                            </div>




                            {/* Price and Discount*/}

                            <div className="flex gap-4">
                                <div className='space-y-2 w-full'>
                                    <h4 className="font-medium text-sm">Product Price</h4>
                                    <Input
                                        id="base_price"
                                        value={formData.base_price}
                                        onChange={handleInputChange}
                                        placeholder="Price"
                                    />
                                </div>

                                {/* Discount */}

                                <div className='space-y-2 w-full'>
                                    <h4 className="font-medium text-sm">Discount</h4>
                                    <Input
                                        id="discount"
                                        value={formData.discount}
                                        onChange={handleInputChange}
                                        placeholder="Dicount %"
                                    />
                                </div>
                            </div>

                            {/* Product Variants */}

                            {/* Customise and Publish and isBundleProduct */}
                            <div className="flex gap-4">
                                <Checkbox
                                    value={formData.customable}
                                    label={"Customised"}
                                    onChange={(e) => setFormData({ ...formData, customable: e.target.checked })}
                                    checked={formData.customable}
                                />
                                <Checkbox
                                    value={formData.in_stock}
                                    label={"In Stock"}
                                    checked={formData.in_stock}
                                    onChange={(e) => setFormData({ ...formData, in_stock: e.target.checked })}
                                />
                            </div>


                            {/* Customise price */}
                            {formData?.customable && (
                                <div className='space-y-2 w-full'>
                                    <h4 className="font-medium text-sm">Customisation Price</h4>
                                    <Input
                                        id="customise_price"
                                        value={formData.customise_price}
                                        onChange={handleInputChange}
                                        placeholder="Customisation Price"
                                    />
                                </div>
                            )}

                        </div>



                        {/* Form 2 ===================================================  */}
                        <div className="w-full xl:w-5/12 space-y-7">


                            {/* Promotions and Deals */}
                            <div className='space-y-3 w-full'>
                                <Checkbox
                                    value={isPromo}
                                    label={"Promotion and Deal"}
                                    checked={isPromo}
                                    onChange={(e) => setIsPromo(!isPromo)}
                                />

                                {isPromo && (
                                    <div className="space-y-3">
                                        <div className='space-y-2 w-full'>
                                            <h4 className="font-medium text-sm">Deal Price</h4>
                                            <Input
                                                id="dealPrice"
                                                value={formData.dealPrice}
                                                onChange={handleInputChange}
                                                type='number'
                                            />
                                        </div>

                                        <div className='space-y-2 w-full'>
                                            <h4 className="font-medium text-sm">Deal Start</h4>
                                            <Input
                                                id="dealStart"
                                                value={formatDateForInput(formData.dealStart)}
                                                onChange={handleInputChange}
                                                type='datetime-local'
                                            />
                                        </div>

                                        <div className='space-y-2 w-full'>
                                            <h4 className="font-medium text-sm">Deal End</h4>
                                            <Input
                                                id="dealEnd"
                                                value={formatDateForInput(formData.dealEnd)}
                                                onChange={handleInputChange}
                                                type='datetime-local'
                                            />
                                        </div>
                                    </div>
                                )}

                            </div>

                            {/* Product Gallery  */}
                            <div className='space-y-2 w-full'>
                                <h4 className="font-medium text-sm">Product Gallery</h4>
                                {/* View Images */}
                                {images.length ? (
                                    <div className="flex flex-wrap gap-4">
                                        {images.map((image, i) => (
                                            <div key={i} className='relative max-w-28 p-1 border rounded-lg'>
                                                <button onClick={() => setImages(images.filter(img => img !== image))} className='absolute p-2 bg-white rounded-lg text-red-600'><IoTrash /></button>
                                                <img src={displayImage(image)} alt="" className='w-full object-cover' />
                                            </div>
                                        ))}
                                    </div>
                                ) : null}

                                <div className="mt-4">
                                    <ImageContainer onSuccess={(file) => setImages([...images, ...file])} />
                                </div>
                            </div>



                            {/* Add Product */}
                            < div className='py-9 border-t' >
                                <Button loading={isPending} onClick={addProduct} color="primary">Update Product</Button>
                            </div>

                        </div>
                    </div>
                </Container>
            </div>
        </div>
    )
}

export default EditProduct